function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "var(--primary-color, #000)",
  fill: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.931 20.901l7.715 5.606-2.947 9.069h-9.536l-2.947-9.07z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.901 4.79) scale(.90136)",
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  transform: "scale(-1 1)",
  cx: -22.168,
  cy: 26.929,
  r: 27.034,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.231
}), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.109
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.222 18.275v-8.12M5 22.501l8.722 1.873M30.722 24.375l8.15-1.856M27.322 34.175l5.155 6.225M16.922 34.075L12.1 40.4"
}))), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.109
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.082 13.928l7.896-3.25-3.127-5.257h-9.537l-3.127 5.258zM12.408 25.071l-.657-8.342-5.492 1.178-2.738 9.07 4.251 4.427zM43.091 25.071l.663-8.342 5.548 1.178 2.766 9.07-4.29 4.427zM18.959 41.19l-8.152-1.907-.706 5.986 7.715 5.606 5.474-2.522zM37.326 41.19l8.152-1.907.706 5.986-7.715 5.606-5.475-2.522z",
  strokeWidth: 0.99960824
})), /*#__PURE__*/React.createElement("path", {
  d: "M27.882 4.854l23.089 16.775-8.82 27.143h-28.54L4.794 21.629z",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var SvgSoccerball = function SvgSoccerball(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSoccerball, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Soccer ball.15430178.svg";
export { ForwardRef as ReactComponent };